const GRAINS = [0, 1, 2, 3, 4];

// Ceres mark: an open "C" ring (Harvest orange) cradling a wheat ear.
export const CeresMark = ({ size = 120, tone = "light", animate = false, delay = 0, className = "" }) => {
  const ring = tone === "dark" ? "#FFFFFF" : "#183457";
  const d = (n) => (animate ? { animationDelay: `${delay + n}ms` } : undefined);
  const a = (cls) => (animate ? cls : "");
  return (
    <svg viewBox="0 0 120 120" width={size} height={size} className={className} aria-hidden="true" focusable="false">
      <path d="M98.1 38 A44 44 0 1 0 98.1 82" fill="none" stroke="#F19E38" strokeWidth="5" strokeLinecap="round"
        pathLength="1" className={a("ceres-draw")} style={d(0)} />
      <path d="M60 96 C58 80 62 56 60 26" fill="none" stroke={ring} strokeWidth="3" strokeLinecap="round"
        pathLength="1" className={a("ceres-draw")} style={d(350)} />
      {GRAINS.map((i) => {
        const y = 36 + i * 11;
        return (
          <g key={i}>
            <g transform={`rotate(-38 52 ${y})`}>
              <ellipse cx="52" cy={y} rx="4.2" ry="8.5" fill="#F19E38"
                className={a("ceres-pop")} style={{ transformBox: "fill-box", transformOrigin: "center", ...d(650 + i * 90) }} />
            </g>
            <g transform={`rotate(38 68 ${y + 4})`}>
              <ellipse cx="68" cy={y + 4} rx="4.2" ry="8.5" fill="#F19E38"
                className={a("ceres-pop")} style={{ transformBox: "fill-box", transformOrigin: "center", ...d(700 + i * 90) }} />
            </g>
          </g>
        );
      })}
      <ellipse cx="60" cy="22" rx="3.8" ry="7.5" fill="#F19E38" className={a("ceres-pop")}
        style={{ transformBox: "fill-box", transformOrigin: "center", ...d(1150) }} />
    </svg>
  );
};
